import { color } from '@primer-io/goat'
import { createGlobalStyle, css } from 'styled-components'
import generateCSSColorVariables from 'utils/generateCSSColorVariables'
import generateCSSEasingVariables from 'utils/generateCSSEasingVariables'

const GlobalStyle = createGlobalStyle`
		${generateCSSColorVariables}
		${generateCSSEasingVariables}

		html {
			background-color: var(--color-white);
			color: var(--color-text);
			-webkit-font-feature-settings: 'kern' 1, 'liga' 1, 'calt' 1, 'pnum' 0, 'tnum' 1, 'onum' 0, 'lnum' 1, 'dlig' 1, 'zero' 1, 'case' 1;
			font-feature-settings: 'kern' 1, 'liga' 1, 'calt' 1, 'pnum' 0, 'tnum' 1, 'onum' 0, 'lnum' 1, 'dlig' 1, 'zero' 1, 'case' 1;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			font-smoothing: antialised;
			text-rendering: optimizeLegibility;
		}
		
		body {
			color: ${color('gray-900')}
			background: red !important;
		}

		*[class^='goat'], *[class*=' goat']{
			-webkit-font-feature-settings: initial;
			font-feature-settings: initial;
			-webkit-font-smoothing: initial;
			-moz-osx-font-smoothing: initial;
			font-smoothing: initial;
			text-rendering: initial;
		}

		::selection {
			background-color: var(--color-text);
			color: var(--color-white);
		}

		html, body, #___gatsby, #gatsby-focus-wrapper {
			box-sizing: border-box;
			display: flex;
			flex: 1;
			flex-direction: column;
			min-height: 100%;
			place-content: flex-start;
		}

		${({ theme }) => css`
			html {
				font-family: ${theme.typography.fonts.sans};
			}
		`}
	`

export default GlobalStyle
